import { render } from "./CostQuery.vue?vue&type=template&id=672ea14c&scoped=true"
import script from "./CostQuery.vue?vue&type=script&lang=js"
export * from "./CostQuery.vue?vue&type=script&lang=js"

import "./CostQuery.vue?vue&type=style&index=0&id=672ea14c&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-672ea14c"

export default script